module.exports = __webpack_public_path__ + "static/media/vf_wtshirts_core.da7c8045.svg";